// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resubmission-notice[data-v-6170a7c2]{color:#3b3e66;font-weight:700;font-size:16px}.button__create-new-submission[data-v-6170a7c2]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
